import React from 'react';

function createProxyFromRef<T extends object>(ref: React.MutableRefObject<T | null>) {
  return new Proxy(ref, {
    get(target, p) {
      if (target.current && p in target.current) {
        return target.current[p as keyof T];
      }

      return undefined;
    },
    // @ts-expect-error
    has(target, p) {
      return target.current?.[p as keyof T];
    },
    ownKeys(target) {
      return target.current ? [...Reflect.ownKeys(target.current)] : [];
    },
    getOwnPropertyDescriptor(target, key) {
      return Object.getOwnPropertyDescriptor(target.current, key);
    },
    set(target, key, value) {
      return false;
    },
    deleteProperty(target, key) {
      return false;
    },
  }) as T;
}

export default createProxyFromRef;
